export const loyaltyIdNamesByParentChain = {
  marriott: 'Marriott Bonvoy #',
  ihg: 'IHG rewards #',
  choice: 'Choice provileges #',
  hyatt: 'World of Hyatt #',
  radisson: 'Radisson Rewards #',
  wyndham: 'Wyndham Rewards #',
  hilton: 'Hilton Honors #',
  bestwestern: 'Membership #'
}
